<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowBinauralRate',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_ha_sold', throughMonth),
          2 * this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
        );
      },
    },
  };
</script>
